import BaseRequestLoadPageMixin from "@/modules/core/request/protected/BaseRequestLoadPageMixin";
import editor from "./CreditAssignmentRequestEditor";
import service from "./CreditAssignmentRequestService";

export default {
  mixins: [BaseRequestLoadPageMixin],

  components: {
    editor
  },

  methods: {
    getService() {
      return service;
    },

    getLabel(instance) {
      return instance.title;
    }
  }
};
